import React, { useContext } from "react";

import { OrganizationFeaturesFragment as OrganizationFeaturesType } from "./gql/Fragment.generated";

import { useCurrentOrganization } from "components/WithCurrentOrganization";

export type Feature = Exclude<keyof OrganizationFeaturesType, "__typename">;
export const FeatureContext = React.createContext({});

export const OrganizationFeatures = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const currentOrganization = useCurrentOrganization(true);
  if (!currentOrganization) {
    return <>{children}</>;
  }

  const { enabledFeatures } = currentOrganization;

  return (
    <FeatureContext.Provider value={enabledFeatures}>
      {children}
    </FeatureContext.Provider>
  );
};

export const useFeature: (feature: Feature | undefined) => boolean = (
  feature,
) => {
  const features = useContext(FeatureContext);
  if (!features) {
    throw new Error(
      "must have ancestor OrganizationFeatures component and current organization",
    );
  }
  if (!feature) {
    return true;
  }
  return features[feature as keyof typeof features];
};
